import { forceUpdate } from 'ionicons/dist/types/stencil-public-runtime';
import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { mapDivEnterToClick } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const InsertionAngleUI = (props: UIProperties<InsertionAngleUIConfig>) => {
	const [selectedAngleIndx, setSelectedAngleIndx] = useState(0);
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '870px',
				height: '680px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '870px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='cric-insertion-angle-ui-top'>Insertion Angle</p>
				</div>
				<div style={{
					width: '100%',
					height: '610px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					
					<CustomInsertionAngleButton 
						showYellowThingyOnTheSide={selectedAngleIndx === 0}
						width= '220px'
						height= '140px'
						img='./assets/images/cric/insertion-angle/AngleA.png'
						text= 'Angle A'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '77px',
							left: '50px'
						}}
						onClicked={() => {
							setSelectedAngleIndx(0);
						}}/>
					<CustomInsertionAngleButton 
						showYellowThingyOnTheSide={selectedAngleIndx === 1}
						width= '220px'
						height= '140px'
						img='./assets/images/cric/insertion-angle/AngleB.png'
						text= 'Angle B'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '77px',
							left: '320px'
						}}
						onClicked={() => {
							setSelectedAngleIndx(1);
						}}/>

					<CustomInsertionAngleButton 
						showYellowThingyOnTheSide={selectedAngleIndx === 2}
						width= '220px'
						height= '140px'
						img='./assets/images/cric/insertion-angle/AngleC.png'
						text= 'Angle C'
						isDisabled={false}
						position= {{
							type: 'absolute', 
							top: '77px',
							left: '590px'
						}}
						onClicked={() => {
							setSelectedAngleIndx(2);
						}}/>
					
					<CustomInsertionAngleSlider></CustomInsertionAngleSlider>

					<GeneralButtonWithText parameters= {{
						text: 'Next',
						id: 'cric-insertion-angle-ui-bottom',
						ariaLbl: 'Next',
						top: '480px',
						left: '340px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.OnNextClicked(selectedAngleIndx, selectedDepth)
						}
					}}/>
				</div>
				
			</div>
		</div>
	);
};

const sliderKnobId = Tools.generateGuid();
const sliderKnob2Id = Tools.generateGuid();
const sliderKnobParentId = Tools.generateGuid();
var isHoveringOverBg = false;
var selectedIndx = 0;
var selectedDepth = 0;
var inited = false;

const CustomInsertionAngleSlider = () => {
	const availableXPos= [
		47,
		141,
		234,
		330,
		424,
		519,
		613,
		700
	];

	const items = [3, 4, 5, 6, 7, 8, 9, 10];

	const [xPos, setXPos] = useState(0);
	const [isDragging, setIsDragging] = useState(false);
	const [forceUpdate, setForceUpdate] = useState(false);

	const mouseMoveMethod = (event: MouseEvent) => { 
		// (window as any)['currentInsertionAngleSliderDragData'] = {
		// 	top: event.clientY,
		// 	left: event.clientX,
		// 	img: (window as any)['currentDraggedItemPositionData'].img
		// }  
		// var el = document.getElementById(sliderKnobId)
		// el.style.top = 'px';
		if(isHoveringOverBg) {
			if(!inited) {
				var el = document.getElementById(sliderKnobId)
				var el2 = document.getElementById(sliderKnob2Id);
				var scale = el2.getBoundingClientRect().width / el2.offsetWidth;
				el.style.transform = 'translate(-50%, -50%) scale(' + scale + ')'
				el.style.visibility = 'visible';

				el.style.top = ($('#' + sliderKnob2Id).offset().top + (40 * scale)) + 'px';
				
				document.body.appendChild(el);
				el2.style.visibility = 'hidden'
				console.log(document.getElementById(sliderKnob2Id))
				inited = true;
			}
			
			setXPos(event.clientX);
		}
	};

	const mouseUpMethod = () => { 
		// (window as any)['currentInsertionAngleSliderDragData'] = {
		// 	top: 0,
		// 	left: 0
		// }
		setIsDragging(false);
		var el = document.getElementById(sliderKnobId);
		document.getElementById(sliderKnobParentId).appendChild(el);

		el.style.visibility = 'hidden'

		var el2 = document.getElementById(sliderKnob2Id);
		el2.style.visibility = 'visible'

		el2.style.left = (availableXPos[selectedIndx] - 40) + 'px';
		inited = false;

		selectedDepth = items[selectedIndx];

		// setDataBeingDragged(null);
		window.removeEventListener('mousemove', mouseMoveMethod);
		window.removeEventListener('mouseup', mouseUpMethod);
	};

	return (
		<div style={{
			position: 'absolute',
			top: '280px',
			left: '50%',
			width: '750px',
			height: '190px',
			transform: 'translate(-50%, 0)'
		}}>
			<p className='title-font' style={{
				textAlign: 'center',
				margin: '0',
				fontSize: '18pt',
				fontWeight: 'normal'
			}} tabIndex={0}>Insertion Depth (cm) from Endotracheal tube insertion depth of cuff past skin</p>
			<div style={{
				position: 'relative',
				left: '50%',
				transform: 'translate(-50%, 0)',
				width: '100%',
				top: '20px'
			}}>
				<div style={{
					border: '3px solid rgb(192, 161, 6)',
					backgroundColor: 'rgb(0, 85, 178)',
					width: '100%',
					height: '40px'
				}}>
				</div>
				<div style={{
					backgroundColor: 'transparent',
					width: '100%',
					height: '40px',
					position: 'absolute',
					top: '0',
					left: '50%',
					transform: 'translate(-50%, 0)',
					pointerEvents: 'all'
					// backgroundColor: 'red'
				}} tabIndex={0} aria-label={'Current Depth. ' + items[selectedIndx]} onMouseOver={() => {
					if(!isHoveringOverBg) {
						isHoveringOverBg = true;
					}
				}} onMouseOut = {() => {
					if(isHoveringOverBg) {
						isHoveringOverBg = false;
					}
				}} onMouseDown={() => {
					if(!isDragging) {
						setIsDragging(true);
						
						// (window as any)['currentInsertionAngleSliderDragData'] = {
						// 	top: -1000,
						// 	left: -1000
						// }
						window.addEventListener('mousemove', mouseMoveMethod);
						window.addEventListener('mouseup', mouseUpMethod);
					}
				}}  id={sliderKnobParentId}>
					<div style={{
						height: '80px',
						width: '80px',
						position: 'absolute',
						left: xPos,
						top: '55vh',
						pointerEvents: 'none',
						visibility: 'hidden'
					}} id={sliderKnobId}>
						<img style={{
							pointerEvents: 'none',
							height: '80px',
						}} 
						src='./assets/images/cric/insertion-angle/slider_circle.png' />
					</div>
					<div style={{
						height: '200%',
						width: '80px',
						position: 'relative',
						top: '-20px',
						left: xPos
					}}  id={sliderKnob2Id}>
						<img style={{
							pointerEvents: 'none',
							height: '80px'
						}} 
						src='./assets/images/cric/insertion-angle/slider_circle.png' />
					</div>
					<div style={{
						width: '100%',
						height: '100%',
						position: 'absolute',
						top: '0',
						left: '0',
						display: 'grid',
						gridTemplateColumns: 'auto auto auto auto auto auto auto auto'
					}}>
						{items.map((el: number, indx: number) => {
							return <div style={{
								// backgroundColor: 'rgb(' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) + ',' + Math.floor(Math.random() * 255) +')'
							}} tabIndex={0} aria-label={el.toString()} role='button' onKeyUp={mapDivEnterToClick} onClick={() => {
								selectedIndx = indx;
								selectedDepth = items[selectedIndx];
								mouseUpMethod();
								// setForceUpdate(!forceUpdate)
							}} onMouseOver={() => {
								selectedIndx = indx;
							}}></div>
						})}
					</div>
				</div>

				<div style={{
					backgroundColor: 'transparent',
					width: '100%',
					height: '40px',
					position: 'relative',
					top: '30px'
				}}>
					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '37px'
					}}>3</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '131px'
					}}>4</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '224px'
					}}>5</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '320px'
					}}>6</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '414px'
					}}>7</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '509px'
					}}>8</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '603px'
					}}>9</p>

					<p className='title-font' style={{
						margin: '0',
						fontSize: '28pt',
						fontWeight: 'normal',
						position: 'absolute',
						top: '0',
						left: '680px'
					}}>10</p>
				</div>
			</div>
		</div>
	);
}

const CustomInsertionAngleButton = (props: CustomInsertionAngleButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: props.width,
			height: props.height,
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					ariaLbl: props.text,
					top: '0px',
					left: '0px',
					isDisabled: props.isDisabled,
					width: props.width,
					srcIdle: "./assets/images/main-menu/button_menu_exit.png",
					srcHighlight: null,
					srcDisabled: './assets/images/main-menu/button_menu_exit_down.png',
					customMainStyle: {
						position: 'relative',
						// width: props.isFlipped ? '99px' : '129px',
						// transform: props.isFlipped ? 'scaleX(-1)' : 'scaleX(1)'
					},
					customImgStyle: {
						width: '100%',
						height: props.height,
						maxWidth: 'none'
					},
					customButtonStyle: {
						width: '100%',
						height: props.height,
					},
					onClicked: () => {
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'absolute',
					height: '100%',
					pointerEvents: 'none',
					width: '100%',
					left: '0',
					top: '0'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						left: '50%',
						width: '70%',
						transform: 'translate(-50%, -50%)'
					}}>
						<img src={props.img} alt="" />
					</div>
					
				</div>
				<div style={{
					position: 'absolute',
					height: '100%',
					pointerEvents: 'none',
					width: '100%',
					left: '0',
				}}>
					<div style={{
						position: 'relative',
						top: '0',
						left: '50%',
						width: '70%',
						transform: 'translate(-50%, 0)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '18pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
				</div>


				{props.showYellowThingyOnTheSide ? (
					<img style={{
						position: 'absolute',
						top: '1px',
						right: '-33px',
						width: '39px',
						pointerEvents: 'none'
					}} src="./assets/images/general/buttons/button_side_pointer.png" />
				) : (null)}
			</div>
		</div>
	);

};

interface CustomInsertionAngleButtonConfig {
	img: string;
	text: string;
	width: string;
	height: string;
	position: CustomInsertionAnglePosition;
	showYellowThingyOnTheSide?: boolean;
	isDisabled?: boolean;
	onClicked: () => void;
}

interface CustomInsertionAnglePosition {
	type?: any;
	left: string;
	top: string;
}

export interface InsertionAngleUIConfig extends BaseConfig{
	OnNextClicked: (selectedAngleIndx: number, selectedDepth: number) => void;
}

export default InsertionAngleUI;